export const buildSeoTitle = (t, title = '', skilletoSuffix = true) => {
  const out = (title || '').trim().length > 0
    ? skilletoSuffix ? `${title.trim()} | ${t('common:seoTitle')}` : title.trim()
    : t('common:seoTitle');

  return out
    .replace(/[.]+/g, '.')
    .replace(/[\n]+/g, ' ')
    .replace(/[ ]+/g, ' ')
    .replace(/[\u202f\xa0]+/g, ' ')
    .trim();
};

// home page
export const buildSeoDescription = (t, searchTitle = '', topSkills = '', maxRate = null) =>
  `${searchTitle} ${t(`userportal:jobs.descriptionSuffix${maxRate ? '' : 'No'}Rate`, { maxRate: (maxRate || '').replace(/[\u202f\xa0]+/g, ' ') })} ${topSkills}`.replace(/[ ]+/g, ' ').trim();

// job, company
export const buildMetaDescription = (text, maxLength = 500) => (text || '').toString()
  .replace(/(<([^>]+)>)/gi, '\n')
  .replace(/[.]+/g, '.')
  .replace(/[\n]+/g, ' ')
  .replace(/[ ]+/g, ' ')
  .replace(/[\u202f\xa0]+/g, ' ')
  .trim()
  .substring(0, maxLength - 3)
  .concat((text || '').length > maxLength - 3 ? '...' : '');

export const developerSuffixSkills = [
  'java', 'javascript', 'python', 'c-plus-plus', 'c', 'php', 'dot-net', 'android', 'node-dot-js', 'ruby',
  'ios', 'c-sharp', 'angular', 'r', 'ruby-on-rails', 'scala', 'go', 'objective-c', 'swift', 'asp-dot-net',
  'react', 'django', 'j2ee', 'perl', 'spring', 'spring-boot', 'pl-sql', 'typescript', 'flask', 'symfony',
  'kotlin'
];

export default {
  buildSeoTitle,
  buildSeoDescription,
  buildMetaDescription,
  developerSuffixSkills,
};
